<template>
    <div class="background-circle-2">
        <svg width="1440" height="465" viewBox="0 0 1440 465" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.21" x="-106" width="1651" height="1650" rx="825" fill="#CBD5FB"/>
        </svg>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.background-circle-2 {
    display: flex;
    justify-content: center;

    svg {
        width: 100%;
    }
}
</style>
